function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5216 25.7557V12.9031",
  stroke: "#434343",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.2937 28.0431H15.7587L16.58 25.7559H22.4724L23.2937 28.0431Z",
  stroke: "#434343",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5215 12.9127C20.1227 12.9127 20.6102 12.4242 20.6102 11.8217C20.6102 11.2192 20.1227 10.7307 19.5215 10.7307C18.9202 10.7307 18.4328 11.2192 18.4328 11.8217C18.4328 12.4242 18.9202 12.9127 19.5215 12.9127Z",
  stroke: "#434343",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M25.5572 14.8459H13.486",
  stroke: "#434343",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M10.7355 20.5689C10.714 20.9273 10.7657 21.2862 10.8877 21.6237C11.0097 21.9612 11.1993 22.2702 11.4448 22.5316C11.6904 22.7929 11.9867 23.0012 12.3155 23.1435C12.6444 23.2859 12.9988 23.3593 13.357 23.3593C13.7152 23.3593 14.0697 23.2859 14.3985 23.1435C14.7274 23.0012 15.0237 22.7929 15.2692 22.5316C15.5148 22.2702 15.7044 21.9612 15.8263 21.6237C15.9483 21.2862 16.0001 20.9273 15.9785 20.5689L13.486 14.8269L10.7355 20.5689Z",
  stroke: "#434343",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M10.7354 20.5688H15.9784",
  stroke: "#434343",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M22.7972 20.5689C22.7972 21.2669 23.0739 21.9363 23.5664 22.4299C24.0589 22.9234 24.7269 23.2007 25.4234 23.2007C26.12 23.2007 26.788 22.9234 27.2805 22.4299C27.773 21.9363 28.0497 21.2669 28.0497 20.5689L25.5476 14.8269L22.7972 20.5689Z",
  stroke: "#434343",
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M22.8066 20.5688H28.0496",
  stroke: "#434343",
  strokeLinejoin: "round"
});

var SvgScalesComputer = function SvgScalesComputer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgScalesComputer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/scales-computer.c6ae0d26.svg";
export { ForwardRef as ReactComponent };